module.exports = __webpack_public_path__ + "static/img/5.716e93f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/2/zh/5.png
// module id = Ak3Q
// module chunks = 0